<template>
  <div class="shippingForm">
     <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(handlSaveAddress)">
        <div class="form" style="margin-top: 0rem;">
          <div v-if="address.country !== 'JP'" class="form-item ">
            <ValidationProvider name="firstName" rules="required|min:1"
            v-slot="{ errors }" slim>
              <SfInput v-e2e="'shipping-firstName'" v-model="address.firstName" :label="$t('MyAccount_MyShippingDetails_First')"
                     name="firstName"
                    class="form__element form__element--half" required :valid="!errors[0]" :errorMessage="$t(errors[0])"/>
            </ValidationProvider>
          </div>
          <div class="form-item ">
            <ValidationProvider name="lastName" rules="required|min:1" v-slot="{ errors }" slim>
              <!-- :placeholder="address.country !== 'JP' ? $t('MyAccount_MyShippingDetails_Last') : $t('order_shopping_firstname')" -->
              <SfInput v-e2e="'shipping-lastName'" v-model="address.lastName"
                    :label="address.country !== 'JP' ? $t('MyAccount_MyShippingDetails_Last') : $t('order_shopping_firstname')"
                    name="lastName" class="form__element form__element--half " required
                    :class="{ 'form__element--half-even': address.country !== 'JP' }" :valid="!errors[0]" :errorMessage="$t(errors[0])" />
            </ValidationProvider>
          </div>
          <div class="form-item form-select full-width">
            <!-- <div style="display: none;">{{ countryErr }}</div> -->
            <ValidationProvider name="country" rules="required|min:2" v-slot="{ errors }" slim>
              <SfSelect v-if="countries" v-model="address.country"  :label="$t('Country')"  class="form__element form__select"
                @input="($event)=>changeCounry($event)" :valid="countryErr? !countryErr.code : !errors[0]" :errorMessage="(countryErr ? countryErr.message :$t(errors[0]))" >
                <SfSelectOption v-for="countryOption in countries" :key="countryOption.key"
                  :value="countryOption.simple_speech">
                  {{ $t(countryOption.simple_speech) }}
                </SfSelectOption>
              </SfSelect>
            </ValidationProvider>
          </div>
          <div class="form-item form-select "  style="margin-top:1rem;">
            <ValidationProvider name="state" rules="required" v-slot="{ errors }" slim>
              <SfSelect v-e2e="'shipping-state'" v-model="address.state" :label="$t('MyAccount_MyShippingDetails_State')"
                  name="state" class="form__element form__element--half form__select sf-select--underlined"
                  :valid="!errors[0]" :errorMessage="$t(errors[0], { min: 2 })"  @input="($event)=>changeState($event)" >
                  <SfSelectOption v-if="provinces" v-for="province in provinces" :key="province.id"
                    :value="province.countries_library_nodes_name">
                    {{ province.countries_library_nodes_name }}
                  </SfSelectOption>
                </SfSelect>
            </ValidationProvider>
          </div>
          <div v-if="address.country !== 'JP'" name="city" class="form-item " style="margin-top:1rem;">
            <ValidationProvider v-if="address.country !== 'JP'" name="city" rules="required" v-slot="{ errors }" slim>
              <SfInput v-e2e="'shipping-city'" v-model="address.city"  :label="$t('MyAccount_MyShippingDetails_City')"
                  name="city" class="form__element form__element--half" required :valid="!errors[0]"
              :errorMessage="$t(errors[0])" />
            </ValidationProvider>
          </div>
          <div class="form-item " :style="{marginTop: address.country !== 'JP'?'0':'1rem'}">
            <ValidationProvider name="streetName" rules="required" v-slot="{ errors }" slim>
              <SfInput v-e2e="'shipping-streetName'" v-model="address.streetName"

                    :label="address.country !== 'JP' ? $t('MyAccount_MyShippingDetails_Street') : $t('Shipping_details')"
                    name="streetName" class="form__element form__element--half" :valid="!errors[0]"
                :errorMessage="$t(errors[0])" required />
            </ValidationProvider>
          </div>
          <!-- <div class="form-item " v-if="address.country !=='JP'" >
            <ValidationProvider name="apartment" rules="required" v-slot="{ errors }" slim>
              <SfInput v-e2e="'shipping-apartment'" v-model="address.apartment"
              :label="$t('MyAccount_MyShippingDetails_HouseNumber')"
                    :placeholder="$t('MyAccount_MyShippingDetails_HouseNumber')" name="apartment"
                    class="form__element form__element--half" required :valid="!errors[0]"
                :errorMessage="$t(errors[0])" />
            </ValidationProvider>
          </div> -->
          <div class="form-item ">
            <ValidationProvider name="zipCode" rules="required|min:2" v-slot="{ errors }" slim>
              <SfInput v-e2e="'shipping-zipcode'" v-model="address.zipCode" :label="$t('MyAccount_MyShippingDetails_Zip')"
                name="zipCode" class="form__element form__element--half " required :valid="!errors[0]" :errorMessage="$t(errors[0])" />
            </ValidationProvider>
          </div>
          <div class="form-item full-width">
            <ValidationProvider name="phoneNumber" rules="required|precision" v-slot="{ errors }" slim>
              <SfInput v-e2e="'shipping-phone'" v-model="address.phoneNumber" :label="$t('MyAccount_MyShippingDetails_Phone')"
                    name="phoneNumber"
                    class="form__element form__element--half " required :valid="!errors[0]" :errorMessage="$t(errors[0])" />
            </ValidationProvider>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import {
  SfInput,
  SfSelect
} from '@storefront-ui/vue';
import { ref, onMounted, computed } from '@nuxtjs/composition-api';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required, min } from 'vee-validate/dist/rules';
import { useUserShipping, useGuoJia, useApiError, useProvince, usePreviewOrder } from '@bee-hole/coms';
import { usePreOrderStore } from '~/stores/newPreOrder';
import { EventBus } from '@/plugins/eventBus';
extend('required', {
  ...required,
  message: 'Shipping_valid_required'
});
extend('min', {
  ...min,
  message: 'Shipping_valid_length_min'
});

extend('precision', {
  validate: value => {
    const precision = value.toString()?.length || 0;
    return precision >= 4;
  },
  message: 'Shipping_valid_Phone'
});
export default {
  name: 'ShippingForm',
  props: {
    type: {
      type: String,
      default: 'address'
    }
  },
  setup(props) {
    // 缓存
    const preOrderStore = usePreOrderStore();
    // api
    const {
      addAddress,
      updateAddress,
      error,
      shipping
    } = useUserShipping();
    const { GuoJiaGet, result: countryList } = useGuoJia();
    const { getProvince, result: provinceList } = useProvince();
    const { preorder, error: preOrderErr } = usePreviewOrder();
    // 定义页面数据
    const COUNTRIES = ref();
    const provinces = ref();
    // form
    const observer = ref();
    // 地址
    const address = ref({
      firstName: '',
      lastName: '',
      streetName: '',
      apartment: '',
      city: '',
      state: '',
      country: null,
      postalCode: '',
      phoneNumber: null,
      zipCode: ''
    });
    const handleFormSubmit = async () => {
      const data = JSON.parse(JSON.stringify(address.value));
      return observer.value.validate().then(success => {
        if (success) {
          delete data.addressId;
          return addAddress({address: data}).then(() => {
            // address.value.addressId = shipping.value?.address_id;
            // EventBus.$emit('NewPreviewOrder', address.value);
            if (props.type === 'Billing') {
              preOrderStore.setBuiling(address.value);
            } else {
              preOrderStore.setAddress(address.value);
            }
            return {addressId: shipping.value?.address_id};
          });
        } else {
          return success;
        }
      });
    };
    // 设置省
    const changeState = (value) => {
      address.value.state = value;
      if (props.type === 'Billing') {
        preOrderStore.setBuiling(address.value);
      } else {
        preOrderStore.setAddress(address.value);
      }
      EventBus.$emit('NewPreviewOrder', address.value);
    };
    const changeCounry = async (value) => {
      // address.value.country = value;
      await getProvince({ country_code: value });
      provinces.value = provinceList.value?.list;
      // address.value.state = provinces.value[0]?.countries_library_nodes_name;
      // if (props.type === 'billing') {
      //   preOrderStore.setBuiling(address.value);
      // } else {
      //   preOrderStore.setAddress(address.value);
      // }
      if (provinces.value?.length > 0) {
        changeState(provinces.value?.[0]?.countries_library_nodes_name);
      }
    };
    const countryErr = computed(() => {
      const error = preorder.value?.errs?.find(err => err.code === 7108);
      return error;
    });
    onMounted(async () => {
      await GuoJiaGet();
      COUNTRIES.value = countryList.value;
      if (props.type === 'Billing' && preOrderStore.builing) {
        address.value = JSON.parse(JSON.stringify(preOrderStore.builing));
      } {
        address.value = JSON.parse(JSON.stringify(preOrderStore.address));
      }
      if (!address.value.country) {
        address.value.country = COUNTRIES.value?.[0]?.simple_speech;
      }
      if (address.value.country) {
        changeCounry(address.value.country);
      }
      setTimeout(() => {
        observer.value.validate().then(success => {
          if (success) {
            console.log('Form is valid!');
          } else {
            console.log('Form is invalid!');
          }
        });
      });
    });
    return {
      changeCounry,
      countries: COUNTRIES,
      address,
      provinces,
      observer,
      changeState,
      handleFormSubmit,
      countryErr
    };
  },
  components: {
    SfSelect,
    SfInput,
    ValidationProvider,
    ValidationObserver
  }
};
</script>
<style lang="scss">
.shippingForm{
  .form {
    display: grid;
    gap: 1rem;
    @include for-desktop {
      grid-template-columns: repeat(2, 1fr);
      //  grid-template-columns: 1fr 1fr;
      .full-width {
          grid-column: 1 / -1;
      }
      // 3个一列
      .three-column {
        grid-column: 1 / -1;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 1rem;
      }
    }
    .sf-input__error-message{
      min-height: 0;
    };
    &__select {
      padding: 1rem 0;
    }
    &__element {
      margin: 0 0 0 0;
      @include for-desktop {
        flex: 0 0 100%;
      }
      &--half {
        @include for-desktop {
          flex: 1 1 50%;
        }

        &-even {
          @include for-desktop {
            // padding: 0 0 0 var(--spacer-xl);
          }
        }
      }

    };
    .form-select{
       // border-bottom: 0 !important;
        border: 1px solid var(--c-text);
        padding: 0;
        padding-left:0.5rem;
        height: 45px;
        margin-bottom:0;
        // .sf-select{
        //   padding-top: 0;
        // }
        .sf-select__label{
          // position: relative;
          width: 100%;
          text-align: left;
          top: 1rem;
          position: relative;
        }
    }
    .form-item{
      // border: 1px solid var(--c-text);
       .form__select{
          padding-top: 0.75rem;
       }
       .sf-input__label{
          top: 60%;
          left: 0.5rem;
          color: var(--c-secondary-variant)
       }
      .sf-select__dropdown{
        border-bottom: 0 !important;
        padding-top: 0 !important;
        margin-bottom:var(--spacer-xs) !important;
      }
      .sf-input input{
        // border-bottom: 0 !important;
        border: 1px solid var(--c-text);
        padding-left:0.5rem;
      }
    }
    // .col-column2{
    //   grid-column: 2;
    // }
    // .col-column1{
    //   grid-column: 1;
    // }
  }
}

</style>
